
<template>
  <Loader style="z-index:10000" v-if="loader" />
  <div class="mb-2">
    <Accordion>
      <AccordionTab header="Genera da File">
        <div class="formgrid grid form-file">
          <div class="field col-12 md:col-5">
            <div class="text-center allowed-format mb-1"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
            <div class="button-wrapper">
              <span :class="['label', {'active': fileToUpload.length > 0}]">
                {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
              </span>
              <input id="upload" type="file" ref="file" :key="keyInputReset" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
            </div>
            <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
            <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
          </div>
          <div class="field col-12 md:col-3">
            <label>Tipo fornitura</label>
            <Dropdown
              v-model="selectedTypeFornituraForUpload"
              :options="typesFornitura"
              optionLabel="name"
              optionValue="name"
              class="inputfield w-full"
              @change="onChangeSelectedTypeFornituraForUpload"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label>Provider</label>
            <Dropdown  v-model="selectedTemplateAvailableForUpload" :options="templateAvailableForUpload" optionLabel="name" :filter="true" placeholder="Seleziona provider" class="inputfield w-full" optionDisabled="disabled"/>
            <div v-show="validationErrors.provider && submitted" class="p-error">Campo richiesto.</div>
          </div>
          <div class="field col-12 md:col-1 flex align-items-end">
            <Button label="Genera" @click="generateTemplateFromFile" />
          </div>
        </div>
        <div class="text-400">
          <small>*No intestazioni; Colonna A: fornitura; </small>
        </div>
      </AccordionTab>
      <AccordionTab header="Genera da sistema">
        <div class="card p-3">
          <div class="grid">
            <div class="fornitura-switchin col-12 lg:col-2">
              <label>Tipo fornitura</label>
              <Dropdown
                v-model="selectedTypeFornitura"
                :options="typesFornitura"
                optionLabel="name"
                optionValue="name"
                class="inputfield w-full"
              />
            </div>
            <div v-if="selectedTypeFornitura == 'pod'" class="col-12 lg:col-2">
              <label>Tipo tensione</label>
              <Dropdown
                v-model="selectedTypeTensione"
                :options="typesTensione"
                optionLabel="name"
                optionValue="name"
                class="inputfield w-full"
              />
            </div>
            <div class="produzione field col-12 md:col-2">
              <div class="field-radiobutton">
                <RadioButton v-model="typeProduzione" inputId="nuova" value="nuova" />
                <label for="nuova" class="m-2">Nuova produzione</label>
              </div>
              <div class="field-radiobutton">
                  <RadioButton v-model="typeProduzione" inputId="in_fornitura" value="in_fornitura" />
                  <label for="in_fornitura" class="ml-2">In Fornitura</label>
              </div>
              <!-- <div class="field-radiobutton">
                  <RadioButton v-model="typeProduzione" inputId="in_switching" value="in_switching" />
                  <label for="in_switching" class="ml-2">In Switching</label>
              </div> -->
            </div>
            <div class="field col-12 md:col-2">
              <div v-show="typeProduzione == 'in_fornitura'">
                <label>Udd</label>
                <MultiSelect v-model="selectedUdd" :options="udds" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona udd" class="inputfield w-full" />
              </div>
              <div v-show="typeProduzione == 'nuova'">
                <label>Data decorrenza</label>
                  <Calendar v-model="data_decorrenza" :showIcon="true" :manualInput="false" view="month" dateFormat="mm/yy" class="inputfield w-full" />
              </div>
              <!-- <div v-show="typeProduzione == 'in_fornitura'">
                <label>Distributore</label>
                <MultiSelect v-model="selectedDistributor" :options="distributors" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona distributore" class="inputfield w-full" />
              </div> -->
            </div>
            <div class="field col-12 md:col-2">
              <label>Tipo Offerta</label>
              <MultiSelect v-model="selectedTypeOfferta" :options="typesOfferta" optionLabel="name"  :filter="true" placeholder="Seleziona tipo offerta" class="inputfield w-full" />
            </div>
            <div class="col-12 md:col-2">
              <label><br></label>
              <Button
                label="Cerca"
                @click="searchData"
                icon="pi pi-search"
                iconPos="right"
                class="w-full"
              />
            </div>
          </div>
        </div>
      </AccordionTab>
      <AccordionTab header="Carica switch inviati">
        <div class="formgrid grid form-file">
          <div class="field col-12 md:col-5">
            <div class="text-center allowed-format mb-1"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
            <div class="button-wrapper">
              <span :class="['label', {'active': fileToUploadSwitch.length > 0}]">
                {{fileToUploadSwitch.length > 0 ? fileToUploadSwitch[0].name : 'Seleziona File' }}
              </span>
              <input id="upload" type="file" ref="fileSwitch" :key="keyInputReset" @change="handleFileUploadSwitch( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
            </div>
            <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
            <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
          </div>
          <div class="field col-12 md:col-3">
            <label>Tipo fornitura</label>
            <Dropdown
              v-model="selectedTypeFornituraForUpload"
              :options="typesFornitura"
              optionLabel="name"
              optionValue="name"
              class="inputfield w-full"
              @change="onChangeSelectedTypeFornituraForUpload"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label>Provider</label>
            <Dropdown  v-model="selectedTemplateAvailableForUpload" :options="templateAvailableForUpload" optionLabel="name" :filter="true" placeholder="Seleziona provider" class="inputfield w-full" />
            <div v-show="validationErrors.provider && submitted" class="p-error">Campo richiesto.</div>
          </div>
          <div class="field col-12 md:col-1 flex align-items-center">
            <Button label="Importa" @click="importSwitch" />
          </div>
        </div>

      </AccordionTab>
    </Accordion>
  </div>



  <div v-if="items.length > 0" class="card switchin-calc">
    <div class="formgrid grid mt-4">
      <div class="field col-12 md:col-3">
        <label> <b>Providers:</b></label>
        <MultiSelect v-model="selectedProviders" :options="providers" optionLabel="name" :filter="true" placeholder="Seleziona providers" class="inputfield w-full uppercase text-xs" display="chip" />
      </div>
      <div class="field col-12 md:col-9 pl-4">
        <div class="formgrid grid mb-3">
          <div class="col-12">
            <h6><b>Totale a disposizione:</b></h6>
          </div>
          <!-- <div class="col-4 text-teal-400"> <b> <small>KWH</small>  <p style="font-size:11px">{{(selectedProviders.reduce((acc,curr) => acc + curr.qta, 0)).toFixed(2)}} <span>su</span> </p> {{ total_kwh_available > 0 ? total_kwh_available.toFixed(2) : 0}}</b></div>
          <div class="col-4 text-blue-400"><b> <small>MWH </small> <p style="font-size:11px">{{((selectedProviders.reduce((acc,curr) => acc + curr.qta, 0)) / 1000).toFixed(4)}} <span>su</span> </p> {{ total_kwh_available > 0 ? (total_kwh_available / 1000).toFixed(4) : 0}}</b></div>
          <div class="col-4 text-indigo-400"><b> <small>GWH</small> <p style="font-size:11px">{{((selectedProviders.reduce((acc,curr) => acc + curr.qta, 0)) / 1000000).toFixed(8)}} <span>su</span> </p> {{ total_kwh_available > 0 ? (total_kwh_available / 1000000).toFixed(8) : 0}}</b></div> -->

          <div class="col-4 text-teal-400"> <b> <small>PMA</small>  <p style="font-size:11px">{{ total_pma > 0 ? total_pma.toFixed(2) : 0 }}</p></b></div>
          <!-- <div class="col-4 text-teal-400"> <b> <small>PMA</small>  <p style="font-size:11px">{{ total_pma > 0 ? (total_pma / 1000).toFixed(4) : 0 }}</p></b></div>
          <div class="col-4 text-teal-400"> <b> <small>PMA</small>  <p style="font-size:11px">{{ total_pma > 0 ? (total_pma / 1000000).toFixed(8) : 0 }}</p></b></div> -->

        </div>
        <div class="formgrid grid ">
          <hr class="w-full">
          <DataTable :value="selectedProviders" @rowReorder="onRowReorder" tableStyle="width: 100%">
              <Column field="" header=""   :headerStyle="{'width': '1rem'}">
              <template #body="{ data }">
                <i @click="removeProvider(data.name)" class="cursor-pointer pi pi-times" style="font-size: 1rem"></i>
              </template>
              </Column>
              <Column :rowReorder="true" :headerStyle="{'width': '1rem'}" :reorderableColumn="false" />
              <Column field="name" header=""  style="min-width: 100px; width:90%">
                <template #body="{data}">
                  <InputText :disabled="data.template_name == ''" type="number" v-model.number="data.qta" @update:modelValue="onChangeQtaKwh" class="inputfield w-full" />
                  <Slider :disabled="data.template_name == ''" class="mt-2" v-model="data.qta" :step="1" :min="0" :max="total_kwh_available" @change="onChangeQtaKwh" /> 
                  <div class="flex justify-content-between">
                    <div>
                      <label :for="data.name" class="mt-1 text-700"> <b>{{(data.name).toUpperCase()}}</b></label>
                      <div><small v-if="data.template_name == ''" class="p-error"> Template file assente</small></div>
                    </div>
                    <div>
                      <small class="ml-3 text-400"> {{ ((total_kwh_available == 0 ? 0 : data.qta / total_kwh_available) * 100).toFixed(2)}}%</small>
                    </div>
                  </div>
                </template>
              </Column>
          </DataTable>
        </div>
      </div>
      <div class="col-12 mt-4">
        <div class="flex justify-content-end">
          <Button :disabled="selectedProviders.length == 0 || selectedItems.length == 0 || total_kwh_available < parseFloat((selectedProviders.reduce((acc,curr) => acc + curr.qta, 0)))" @click="calculateQtaProviders" icon="pi pi-chevron-right" iconPos="right" label="Calcola quantità" />
        </div>
      </div>
    </div>
  </div>


  <Accordion lazy v-if="items.length > 0">
    <AccordionTab header="Forniture">
      <template #header>
        <div class="flex justify-content-between flex-wrap w-full">
          <div class="flex align-items-center flex-column">
            <!-- Forniture -->
          </div>
          <i></i>
          <div class="text-left">
            <div class="price "> <small class="text-400 text-xs">TOT.FORNITURE</small> <br>{{items.length}}</div> 
          </div>
        </div>
      </template>
      <div>
        <DataTable
          :value="items"
          tableStyle="width: 100%"
          :filters="filters"
          v-model:selection="selectedItems"
          :paginator="true"
          :rows="50"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50, 200, 500]"
          dataKey="code"
          responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}"
        >
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                  <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
            </div>
          </template>
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3rem" />
          <Column field="code" header="Code" :sortable="true" />
          <Column field="data_switch" header="Data Decorrenza" :sortable="true">
            <template #body="{ data }">
              {{ moment(data.data_switch).format('DD/MM/YYYY') }}
            </template>
          </Column>
          <Column field="prima_data_utile_switch" header="Modalità selezione data switch" :sortable="true" />
          <Column field="data_validazione" header="Data validazione" :sortable="true" v-if="hasColumn(items, 'data_validazione')">
            <template #body="{ data }">
              {{ data.data_validazione != null ? moment(data.data_validazione).format('DD/MM/YYYY') : '' }}
            </template>
          </Column>
          <Column field="data_inizio" header="Data Inizio" :sortable="true">
            <template #body="{ data }">
              {{ data.data_inizio != null ? formatDate(data.data_inizio) : '' }}
            </template>
          </Column>
          <Column field="data_fine" header="Data Fine" :sortable="true">
            <template #body="{ data }">
              {{ data.data_fine != null ? formatDate(data.data_fine) : '' }}
            </template>
          </Column>
          <Column field="cluster" header="Cluster" :sortable="true" />
          <Column field="consumo_annuo" header="Consumo Annuo" :sortable="true" />
          <Column field="pma" header="Pma" :sortable="true" />
          <Column field="remi" header="Remi" :sortable="true" />
          <Column field="cliente" header="Cliente" :sortable="true" />
          <Column field="rappresentante" header="Rappresentante" :sortable="true" />
          <Column field="udd" header="Udd" :sortable="true" />
          <Column field="distributore" header="Distributore" :sortable="true" />
        </DataTable>
      </div>
    </AccordionTab>
  </Accordion> 
  



  <!-- Dialog Confirm -->
  <Dialog
    header="Conferma"
    v-model:visible="dialogConfirm"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '80vw' }"
    modal 
  >
    <div class="w-full">
      <div class="formgrid grid mt-1">
        <div class="col-12 lg:col-6 xl:col-4"> 
          <div class="card">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block text-900 font-medium mb-3">Forniture allocate</span>
                <div class="text-600 font-medium text-xl">{{selectedItems.length}} <small class="small">su {{items.length}} totali</small></div>
              </div>
              <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-bell text-blue-500 text-xl"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-6 xl:col-4"> 
          <div class="card">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block text-900 font-medium mb-3">Tot.kwh allocati</span>
                <div class="text-600 font-medium text-xl">{{selectedItems.reduce((acc,curr) => acc+parseFloat(curr.consumo_annuo), 0)}} <small class="small">su {{items.reduce((acc,curr) => acc+parseFloat(curr.consumo_annuo), 0)}} totali</small></div>
              </div>
              <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-bell text-blue-500 text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Accordion @tab-open="onTabConfirmProviderOpen" lazy>
        <AccordionTab v-for="provider in selectedProviders" :key="provider.name" >
          <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
              <div class="flex align-items-center flex-column">
                <div>
                  <div class="uppercase">{{provider.name}}</div>
                  <div class="text-400 text-xs"><small>{{provider.details.length}} forniture</small></div>
                </div>
              </div>
              <i></i>
              <div class="text-left">
                <div class="price "> <small class="text-400 text-xs">TOT.KWH</small> <br>{{(provider.qta).toFixed(2)}}</div> 
                <!-- <small class="text-500 text-xs">Fatture scadute ({{provider.details.length}})</small>  -->
              </div>
            </div>
          </template>
          <div class="mt-2">
            <DataTable
              :ref="`dt_${provider.name}`"
              :value="provider.details"
              v-model:selection="selectedMovedForniture"
              tableStyle="width: 100%"
              :paginator="true"
              :rows="50"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              :rowsPerPageOptions="[10, 20, 50, 200, 500]"
              dataKey="code"
              responsiveLayout="scroll"
              currentPageReportTemplate="{first} a {last} di {totalRecords}"
              :exportFilename="provider.name"
              csvSeparator=";"
            >
              <template #empty>
                  <div class="text-center">Nessun dato trovato.</div>
              </template>
              <template #header>
                <div class="flex justify-content-between flex-wrap">
                  <div class="flex align-items-center justify-content-start">
                    <Button icon="pi pi-download" label="Esporta" @click="exportCSV(provider.name)" class="p-button-secondary" />
                  </div>
                  <i></i>
                  <div v-if="selectedMovedForniture.length > 0" class="flex align-items-center">
                    Sposta selezionati in: 
                    <br>
                    <Dropdown v-model="movedProvider" :options="provider.other_provider" optionValue="name" optionLabel="name" @change="onMovedFornitureToProvider(provider)" placeholder="Seleziona provider" class="w-full md:w-14rem ml-2" />
                  </div>
                </div>
              </template>
              <Column selectionMode="multiple" headerStyle="width: 3rem" />
              <Column field="code" header="Code" :sortable="true" />
              <Column field="data_switch" header="Data Decorrenza" :sortable="true">
                <template #body="{ data }">
                  {{ moment(data.data_switch).format('DD/MM/YYYY') }}
                </template>
              </Column>
              <Column field="prima_data_utile_switch" header="Modalità selezione data switch" :sortable="true" />
              <Column field="data_validazione" header="Data validazione" :sortable="true" v-if="hasColumn(provider.details, 'data_validazione')">
                <template #body="{ data }">
                  {{ data.data_validazione != null ? moment(data.data_validazione).format('DD/MM/YYYY') : '' }}
                </template>
              </Column>
              <Column field="cluster" header="Cluster" :sortable="true" v-if="selectedTypeFornitura == 'pod'"/>
              <Column field="consumo_annuo" header="Consumo Annuo" :sortable="true" />
              <Column field="pma" header="Pma" :sortable="true" />
              <Column field="remi" header="Remi" :sortable="true" v-if="selectedTypeFornitura == 'pdr'" />
              <Column field="cliente" header="Cliente" :sortable="true" />
              <Column field="rappresentante" header="Rappresentante" :sortable="true" />
              <Column field="agente" header="Agente" :sortable="true" />
              <Column field="ragione_sociale" header="Distributore" :sortable="true" />
              <Column field="data_caricamento" header="Data caricamento" :sortable="true">
                <template #body="{data}">
                  {{ moment(data.data_caricamento).format('DD/MM/Y') }}
                </template>
              </Column>
              <Column field="type" header="Tipo" :sortable="true"/>
              <Column field="matrice_id" header="#ID caricamento" :sortable="true"/>
            </DataTable>
          </div>
        </AccordionTab>
    </Accordion>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        @click="dialogConfirm = false"
        class="p-button-text"
      />
      <Button
        label="Scarica Template"
        icon="pi pi-download"
        @click="downloadSwitchInProviders()"
        class="p-button-primary"
      />
    </template>
  </Dialog>


</template>

<script>
import { FilterMatchMode } from "primevue/api";
import Service from "@/services/ask-pratiche/pratiche-service";
import UtilityService from '@/services/ask-pratiche/utility-service'
import { ref, getCurrentInstance, onMounted, computed } from "vue";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";

export default {
  components: {
    Loader,
  },
  setup (props, {emit}) { 
    const dt = ref();
    const toast = useToast();
    const loader = ref(false);
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const service = new Service(self.$eventBus);
    const utilityService = new UtilityService(self.$eventBus)
    const items = ref([]);
    const selectedItems = ref([]);
    const providers = ref([]);
    const selectedProviders = ref([])
    const movedProvider = ref({})
    const selectedMovedForniture = ref([])
    const typesFornitura = ref([
      { name: "pod" }, 
      { name: "pdr" }, 
    ]);
    const data_decorrenza = ref();
    const selectedTypeFornitura = ref(typesFornitura.value[0].name);
    const selectedTypeFornituraForUpload = ref(typesFornitura.value[0].name);
    const templatesAvailableForUpload = ref([])
    const templateAvailableForUpload = ref([])
    const selectedTemplateAvailableForUpload = ref('')
    const typesTensione = ref([
      { name: "BT" }, 
      { name: "MT" },
      { name: "TUTTI" }
    ]);
    const selectedTypeTensione = ref(typesTensione.value[0].name);
    const typeProduzione = ref('nuova');
    const udds = ref([]);
    const selectedUdd = ref([])
    const distributors = ref([]);
    const selectedDistributor = ref([])
    const typesOfferta = ref([]);
    const selectedTypeOfferta = ref([])
    const requestTypeFornitura = ref('');
    const dialogConfirm = ref(false)
    const keyInputReset = ref(0)
    const fileToUpload = ref([])
    const fileToUploadSwitch = ref([])
    const allowedType = {
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
    const validationErrors = ref({})
    const submitted = ref(false)


    onMounted(()=>{
      getUddsForSwitchin()
      getTypesOffertaForSwitchin()
      getDistributorsForSwitchin()
      getTemplatesAvailable()
    })

    const getTypesOffertaForSwitchin = () => {
      loader.value = true;
      utilityService.getTipiOfferta()
      .then((res) => {       
        typesOfferta.value = res.items
        selectedTypeOfferta.value = typesOfferta.value
      })
      .finally(() => {
        loader.value = false;
      });
    }

    const getUddsForSwitchin = () => {
      loader.value = true;
      service.getUddsForSwitchin(selectedTypeFornitura.value)
      .then((res) => {
        udds.value = res.items
      })
      .finally(() => {
        loader.value = false;
      });
    }

    const getDistributorsForSwitchin = () => {
      loader.value = true;
      service.getDistributorsForSwitchin(selectedTypeFornitura.value)
      .then((res) => {
        distributors.value = res.items
        if (distributors.value.length > 0) {
          distributors.value.forEach(d => {
            selectedDistributor.value.push(d.id)
          });
        }
      })
      .finally(() => {
        loader.value = false;
      });
    }

    const getTemplatesAvailable = () => {
      loader.value = true;
      service.getTemplatesAvailable()
      .then((res) => {
        templatesAvailableForUpload.value = {
          pod: res.items.pod.filter(provider => !provider.disabled),
          pdr: res.items.pdr.filter(provider => !provider.disabled)
        }
        templateAvailableForUpload.value = templatesAvailableForUpload.value[selectedTypeFornituraForUpload.value]
      })
      .finally(() => {
        loader.value = false;
      });
    }

    const onChangeSelectedTypeFornituraForUpload = () => {
      templateAvailableForUpload.value = templatesAvailableForUpload.value[selectedTypeFornituraForUpload.value]
    }

    const normalizePma = (value) => {
      if (value === null || value === undefined || value === '') {
        return value
      }

      return String(value).trim().replace(',', '.')
    }

    const getPmaAsNumber = (value) => {
      const pma = parseFloat(normalizePma(value))
      return Number.isNaN(pma) ? 0 : pma
    }

    const normalizePrimaDataUtileSwitch = (value) => {
      if (value === null || value === undefined || value === '') {
        return value
      }

      if (value === 0 || value === false || value === '0') {
        return 'da agente'
      }

      if (value === 1 || value === true || value === '1') {
        return 'da sistema'
      }

      return value
    }

    const hasColumn = (rows, field) => {
      return Array.isArray(rows) && rows.some((row) => Object.prototype.hasOwnProperty.call(row, field))
    }

    const normalizeSwitchinItem = (item) => ({
      ...item,
      pma: normalizePma(item.pma),
      prima_data_utile_switch: normalizePrimaDataUtileSwitch(
        Object.prototype.hasOwnProperty.call(item, 'prima_data_utile_switch')
          ? item.prima_data_utile_switch
          : item.prima_data_uile_switch
      )
    })

    const searchData = () => {
      loader.value = true;
      providers.value = []
      selectedProviders.value = []
      items.value = []
      selectedItems.value = []
      service.getPdpReadyToSwitch(
        selectedTypeFornitura.value,
        selectedTypeTensione.value,
        typeProduzione.value,
        selectedUdd.value,
        selectedDistributor.value,
        selectedTypeOfferta.value,
        data_decorrenza.value ? moment(data_decorrenza.value).format('YYYY-MM-DD 00:00:00') : null
      )
      .then((res) => {
        items.value = res.response.items.map(normalizeSwitchinItem);
        selectedItems.value = items.value;
        providers.value = res.response.folders.filter((folder) => !folder.disabled);
        selectedProviders.value = providers.value
        requestTypeFornitura.value = res.response.typeFornitura
        distributeEqualKwh()
      })
      .finally(() => {
        loader.value = false;
      });
    };

    const distributeEqualKwh = () => {
      let n_providers = selectedProviders.value.filter(el => el.template_name != '').length
      if (n_providers > 0) {
        let tot = total_kwh_available.value / n_providers
        selectedProviders.value.forEach(p => {
          
          if (p.template_name == '') {
            p.qta = 0
          } else {
            p.qta = parseFloat(tot.toFixed(4))
          }

          p.other_provider = []
          selectedProviders.value.forEach(otherProvider => {
              if (p.name !== otherProvider.name) {
                  p.other_provider.push({'name':otherProvider.name});
              }
          });

        });
      }
    }

    const total_kwh_available = computed(() => {
        let total = 0;
        for(let el of selectedItems.value) {
          total += parseFloat(el.consumo_annuo)
        }
        total += 0.01
        return parseFloat(total.toFixed(2))
    });

    const total_pma = computed (() => {
      let total = 0;
      for(let el of selectedItems.value) {      
        total += getPmaAsNumber(el.pma);
      }
      return parseFloat(total.toFixed(2))
    });

    const onChangeQtaKwh = () => {
      // let n_providers = providers.value.length
      // if (n_providers > 0) {
      //   let tot = total_kwh_available.value / n_providers
      //   providers.value.forEach(p => {
      //     p.qta = parseFloat(tot.toFixed(3))
      //   });
      // }
    }

    const onRowReorder = (event) => {
      selectedProviders.value = event.value
    }

    const onMovedFornitureToProvider = (actualProvider) => {
      // console.log(actualProvider);
      // console.log(movedProvider.value);
      // console.log(selectedMovedForniture.value);
      // console.log(selectedProviders.value);

      


      selectedProviders.value.forEach(provider => {
        if (provider.name == actualProvider.name) {
          selectedMovedForniture.value.forEach(el => {
            provider.qta -= parseFloat(el.consumo_annuo)
            provider.totalConsumption -= parseFloat(el.consumo_annuo)
            provider.details = provider.details.filter(detail => detail.id !== el.id);
          });
        }

        if (provider.name == movedProvider.value) {
          selectedMovedForniture.value.forEach(el => {
            provider.qta += parseFloat(el.consumo_annuo)
            provider.totalConsumption += parseFloat(el.consumo_annuo)
            provider.details.push(el)
          });
        }
        
      });
      selectedMovedForniture.value = []
      movedProvider.value = ''
    }


    const onTabConfirmProviderOpen = () => {
      selectedMovedForniture.value = []
    }


    const calculateQtaProviders = () => {
      let n_providers = selectedProviders.value.filter(el => el.template_name != '').length;

      if (n_providers > 0 && total_kwh_available.value > 0) {
          let remainingKwh = total_kwh_available.value;
          let items = selectedItems.value.slice();

          selectedProviders.value.forEach(provider => {
            provider.details = []
            provider.totalConsumption = 0; // Inizializza la somma del consumo_annuo per ogni provider
          });

          assignItemsToProviders(selectedProviders, items, remainingKwh);
      }

      // distribute new qta e deselect items not consider
      let idsConsiderArray = [];
      selectedProviders.value.forEach(provider => {
          provider.qta = provider.totalConsumption;
          provider.details.forEach(detail => {
            idsConsiderArray.push(detail.id)
          });
      });
      selectedItems.value = selectedItems.value.filter(item => idsConsiderArray.includes(item.id));
      if (selectedItems.value.length > 0) {
        dialogConfirm.value = true
      }

    };



    const assignItemsToProviders = (providers, items, remainingKwh) => {
      let index = 0; // Index variable to keep track of the current position in the items array

      while (index < items.length && remainingKwh > 0) {
          const el = items[index];
          let foundProvider = false;

          for (const provider of providers.value) {
              if (provider.qta >= provider.totalConsumption + parseFloat(el.consumo_annuo) && remainingKwh >= parseFloat(el.consumo_annuo)) {
                  provider.details.push(el);
                  provider.totalConsumption += parseFloat(el.consumo_annuo);
                  remainingKwh -= parseFloat(el.consumo_annuo);
                  foundProvider = true;
                  break;
              }
          }

          // If the provider was found or not, move to the next item
          if (foundProvider) {
              index++;
          } else {
              // Remove the item from the array if no provider is found
              items.splice(index, 1);
          }
      }
    };

    // const assignItemsToProviders = (providers, items, remainingKwh) => {
    //     // Se non ci sono più elementi o energia disponibile, termina la ricorsione
    //     if (items.length === 0 || remainingKwh <= 0) {
    //         return;
    //     }

    //     // Prendi il primo elemento dalla lista di items
    //     const el = items[0];
    //     let foundProvider = false;

    //     // Cerca un provider disponibile per questo elemento
    //     for (const provider of providers.value) {
    //         if (provider.qta >= provider.totalConsumption + el.consumo_annuo && remainingKwh >= el.consumo_annuo) {
    //             provider.details.push(el);
    //             provider.totalConsumption += el.consumo_annuo;
    //             remainingKwh -= el.consumo_annuo;
    //             // Rimuovi l'elemento dalla lista
    //             items.shift();
    //             foundProvider = true;
    //             break;
    //         }
    //     }

    //     // Se il provider non è stato trovato, rimuovi l'elemento dalla lista
    //     if (!foundProvider) {
    //         items.shift();
    //     }

    //     // Richiama ricorsivamente la funzione con l'array di items aggiornato
    //     assignItemsToProviders(providers, items, remainingKwh);
    // };



    const downloadSwitchInProviders = () => {
      if (total_kwh_available.value >= parseFloat((selectedProviders.value.reduce((acc,curr) => acc + curr.qta, 0)).toFixed(2))) {
          loader.value = true;
          service.downloadTemplateSwitchInProviders(
            JSON.stringify(selectedProviders.value),
            requestTypeFornitura.value,
            total_kwh_available.value,
          )
          .finally(() => {
            loader.value = false;
          });
      } else {
        toast.add({severity:'warn', summary: 'Attenzione', detail:'Il totale kwh impostato è maggiore dal totale kwh disponibile'});
      }
    }

    const handleFileUpload = async (evt) => {
      evt.preventDefault()
      fileToUpload.value = []
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
    }
    const handleFileUploadSwitch = async (evt) => {
      evt.preventDefault()
      fileToUploadSwitch.value = []
      submitted.value = false;
      fileToUploadSwitch.value = self.refs.fileSwitch.files
    }

    const generateTemplateFromFile = () => {
      submitted.value = true
      if (validateFiles()) {
        loader.value = true; 
        service.generateTemplateSwitchinFromFile(fileToUpload.value, selectedTypeFornituraForUpload.value, selectedTemplateAvailableForUpload.value)
        .finally(() => {
          // keyInputReset.value = new Date()
          fileToUpload.value = []
          loader.value = false; 
        }) 
      }
    }
    const importSwitch = async () => {
      submitted.value = true
      if (validateFilesSwitch()) {
        loader.value = true; 
        await service.importSwitch(fileToUploadSwitch.value, selectedTypeFornituraForUpload.value, selectedTemplateAvailableForUpload.value)
        .then((res) => {
          let data = res.res.data
          let status = res.res.status

          let severity
          let summary
          let detail = data.message
          switch (status) {
            case 200:
              if (data.success) {
                detail = Object.entries(detail)
                .map(([key, value]) => `${key.replace('_', ' ')}: ${value}`)
                .join(', ');
                severity = 'success'
                summary = 'Successo'
              } else {
                severity = 'warn'
                summary = 'Attenzione'                
              }

              fileToUploadSwitch.value = []
              break;
            default:
              severity = 'error'
              summary = 'Errore'

              break;
          }
          
          toast.add({severity:severity, summary: summary, detail:detail})
        })
        .finally(() => {
          loader.value = false; 
        }) 
      }
    }

    const validateFiles = () => {
      validationErrors.value = {}

      if (selectedTemplateAvailableForUpload.value > '') {
        delete validationErrors.value['provider'];
      } else {
        validationErrors.value['provider'] = true;
      }

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }
    const validateFilesSwitch = () => {
      validationErrors.value = {}

      if (selectedTemplateAvailableForUpload.value > '') {
        delete validationErrors.value['provider'];
      } else {
        validationErrors.value['provider'] = true;
      }

      if (fileToUploadSwitch.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUploadSwitch.value.length > 0) {
        let valid = [...fileToUploadSwitch.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }

    const removeProvider = (name) => {
      selectedProviders.value = selectedProviders.value.filter(el => el.name != name)
    };

    const exportCSV = (name) => {
      self.refs[`dt_${name}`].exportCSV()
    };


    return {
      dt,
      loader,
      formatDate,
      filters,
      searchData,
      udds,
      selectedUdd,
      distributors,
      data_decorrenza,
      selectedDistributor,
      items,
      selectedItems,
      providers,
      selectedProviders,
      movedProvider,
      onMovedFornitureToProvider,
      selectedTypeFornitura,
      selectedTypeFornituraForUpload,
      selectedTemplateAvailableForUpload,
      templatesAvailableForUpload,
      templateAvailableForUpload,
      onChangeSelectedTypeFornituraForUpload,
      fileToUpload,
      fileToUploadSwitch,
      generateTemplateFromFile,
      importSwitch,
      allowedType,
      handleFileUpload,
      handleFileUploadSwitch,
      requestTypeFornitura,
      typesFornitura,
      selectedMovedForniture,
      calculateQtaProviders,
      total_kwh_available,
      onChangeQtaKwh,
      downloadSwitchInProviders,
      submitted,
      typesOfferta,
      selectedTypeOfferta,
      onRowReorder,
      removeProvider,
      dialogConfirm,
      onTabConfirmProviderOpen,
      typesTensione,
      selectedTypeTensione,
      typeProduzione,
      validationErrors,
      keyInputReset,
      exportCSV,
      total_pma,
      hasColumn,
      moment
    };
  },
};
</script>
<style>
.switchin-calc .p-datatable-thead {
  display: none;
}
.switchin-calc .pi-bars {
  cursor: move;
}
.fornitura-switchin .p-dropdown-label{
  text-transform: uppercase !important;
}
.sw-caricati .p-dropdown-label, .p-dropdown-items .p-dropdown-item{
  text-transform: uppercase !important;
}
</style>

<style scoped>
.p-dropdown-items .p-dropdown-item{
  text-transform: uppercase !important;
}
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
.box-wrapper .box {
  cursor: pointer;
}
.box-wrapper .box .card {
    background-color: #f4f4f4;
    padding-bottom: 8px;
}
.box-wrapper .highlight .card{
  /* background: rgba(66, 244, 17, 0.195); */
  border-bottom: 6px solid rgb(18, 158, 251);
  background-color: #fff;
}
.produzione label {
  font-size: 13px;
}

</style>
